import { ActivityType } from '../../interfaces/activity'
import { ClientInfoStatus } from '../../interfaces/client'
import { getReportingDocumentLabel, REPORTING_DOCUMENT_TYPES } from '../client'
import { FilterFieldType, IFilter } from './types'

const excludeReportingDocumentTypes = [
  REPORTING_DOCUMENT_TYPES.arAging,
  REPORTING_DOCUMENT_TYPES.apAging,
  REPORTING_DOCUMENT_TYPES.inventoryDetail,
]
export const NOTIFICATIONS_LIST_FILTERS_CONFIG = [
  {
    field: 'user',
    type: FilterFieldType.Autocomplete,
    dbField: 'user_id',
    alias: 'notification',
    title: 'User',
    placeholder: 'User',
    isCustom: true,
  },
  {
    field: 'first_name',
    type: FilterFieldType.Text,
    dbField: 'first_name',
    alias: 'user',
  },
  {
    field: 'last_name',
    type: FilterFieldType.Text,
    dbField: 'last_name',
    alias: 'user',
  },
  {
    field: 'clientName',
    type: FilterFieldType.Autocomplete,
    dbField: 'client_name',
    alias: 'notification',
    title: 'Client',
    placeholder: 'Client',
  },
  {
    field: 'createdAt',
    type: FilterFieldType.Datetime,
    dbField: 'created_at',
    alias: 'notification',
    title: 'Date',
  },
  {
    field: 'notificationText',
    type: FilterFieldType.Text,
    dbField: 'notification_text',
    alias: 'notification',
    title: 'Text',
    excludeColumn: true,
    isRawText: true,
  },
  {
    field: 'activityType',
    type: FilterFieldType.List,
    dbField: 'type',
    isMultiple: true,
    alias: 'activity',
    options: Object.values(ActivityType).map((value) => ({
      value,
      label: value,
    })),
    title: 'Activity',
  },
  {
    field: 'reportingDocumentType',
    type: FilterFieldType.List,
    isMultiple: true,
    options: Object.values(REPORTING_DOCUMENT_TYPES)
      .filter((value) => !excludeReportingDocumentTypes.includes(value))
      .map((value) => ({
        value,
        label: getReportingDocumentLabel(value),
      })),
    title: 'Reporting Type',
    isCustom: true,
  },
  {
    field: 'isRead',
    dbField: 'is_read',
    type: FilterFieldType.Boolean,
    excludeColumn: true,
    options: [
      {
        value: 'true',
        label: 'Read',
      },
      {
        value: 'false',
        label: 'Unread',
      },
    ],
    title: 'Read',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'clientStatus',
        type: FilterFieldType.List,
      },
    ],
    quickFilters: [
      {
        title: 'Fundings',
        filters: {
          activityType: [ActivityType.Funding],
        },
      },
      {
        title: 'Prospects',
        isHidden: true,
        filters: {
          clientStatus: [ClientInfoStatus.Prospect],
        },
      },
    ],
  },
] as const satisfies IFilter[]
